import ComputerIcon from '@mui/icons-material/Computer';
import { SvgIconProps } from '@mui/material';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import React from 'react';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';

export class ITLeasingBenefitMetadataExtension extends BenefitMetadataExtensionInterface {
  benefitId: BenefitDTOBenefitEnum = BenefitDTOBenefitEnum.ItLeasing;

  get Icon(): React.ComponentType<SvgIconProps> {
    return ComputerIcon;
  }
}
